import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

const clearLocal = () => {
  localStorage.removeItem("syc_user_cache");
  localStorage.removeItem("terreno_sync_result");
  Object.keys(localStorage).filter((k) => k.startsWith("cache:")).forEach((k) => localStorage.removeItem(k));
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(undefined);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      localStorage.setItem("syc_user_cache", JSON.stringify({ id: data.id, name: data.name, permissions: data.permissions, roles: data.roles, scopes: data.scopes }));
      setUser(data);
    } catch (e) {
      const cached = !e.response && localStorage.getItem("syc_user_cache");
      setUser(cached ? { ...JSON.parse(cached), offline: true } : null);
    }
  }, []);

  useEffect(() => {
    load();
    const onLogout = () => { clearLocal(); setUser(null); };
    window.addEventListener("syc:logout", onLogout);
    return () => window.removeEventListener("syc:logout", onLogout);
  }, [load]);

  useEffect(() => {
    if (user && !user.offline) {
      localStorage.setItem("syc_user_cache", JSON.stringify({ id: user.id, name: user.name, permissions: user.permissions, roles: user.roles, scopes: user.scopes }));
      window.dispatchEvent(new Event("syc:user"));
    }
  }, [user]);

  const logout = async () => {
    try { await api.post("/auth/logout"); } finally { clearLocal(); setUser(null); }
  };

  const can = (perm) => !!user?.permissions?.includes(perm);

  return <AuthContext.Provider value={{ user, setUser, reload: load, logout, can }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
